
import { TGoal } from "@assetmark/goal-components/dist/models/goal";
import { TOtherIncome } from "@assetmark/goal-components/dist/models/other-income";
import { Option } from "fp-ts/lib/Option";
import { GoalTypeEnum } from "../lib/das-api/model/goalTypeEnum";
import { LeadOtherRetirementIncome } from "../lib/das-api/model/leadOtherRetirementIncome";
import { ModelPerformanceInput } from "../lib/das-api/model/modelPerformanceInput";
import { TAddUpdateLeadGoal } from "../models/add-update-lead-goal";

export enum EGoalType {
	Unknown = 1,
	Retirement = 2,
	GeneralSavings = 3,
}

const goalTypeEnum = EGoalType;

export const GetGoalTypeDisplayText = (EGoalTypeKey: any): string => {
	let returnItem = '';
	const enumType = Number(EGoalTypeKey);

	if (enumType === goalTypeEnum.Retirement) {
		returnItem = 'Retirement';
	} else if (enumType === goalTypeEnum.GeneralSavings) {
		returnItem = 'General Investing';
	} else if (enumType === goalTypeEnum.Unknown) {
		returnItem = 'Unknown';
	}

	return returnItem;
};

export const parseTGoalToTAddUpdateGoal = (
	leadId: string,
	leadStrategyId: string,
	agentId: string,
	currentRoute: string,
	goal: TGoal,
	goalId: string,
): TAddUpdateLeadGoal => {
	return {
		id: goalId,
		leadId,
		leadStrategyId,
		goalTypeId: 0,
		goalType: goal.GoalType,
		retirementAge: Number(goal.retirementAge || 0),
		targetGrowthAmount: goal.TargetAmount || 0,
		targetGoalYear: goal.TargetYear || 0,
		monthlyIncome: goal.MonthlyIncome || 0,
		monthlyIncomeToRetirePercent: goal.MonthlyIncomeToRetirePercent || 0,
		savingsCurrent: goal.SavingsCurrent || 0,
		annualSavings: goal.AnnualSavings || 0,
		birthYear: goal.BirthYear || 0,
		otherRetirementIncomes: goal.OtherRetirementIncomes
			? goal.OtherRetirementIncomes.map(o => ({
					otherRetirementIncomeID: (o.Id === 0 || o.Id === "0") ? "" : o.Id.toString(),
					incomeSourceTypeId: o.IncomeSourceTypeId,
					monthlyIncome: o.MonthlyIncome || 0,
			  }))
			: [],
		netRetirementMonthlyIncome: goal.NetRetirementMonthlyIncome || 0,
		agentId: agentId,
		investmentAmount: goal.Amount || 0,
		currentRoute: currentRoute,
		lifeExpectancy: goal.LifeExpectancy || 90,
		inflation: goal.Inflation || 0.02,
		investmentTypeEnum: parseGoalTypeToEnum(goal.GoalType),
	};
};

export const getModelPerformanceInput = (amount: number, agentId: string, feeId: Option<number>): ModelPerformanceInput => {
	return {
		accountValue: amount,
		agentId: agentId,
		clientFeeId: feeId.getOrElse(30576),
		custodianId: "GNW",
		houseHoldAmount: amount,
		modelAplId: "P1GBLN",
	};
};

export const parseOtherIncome = (value: LeadOtherRetirementIncome[]) : TOtherIncome[] => {
	if(value.length) {
		return value.map(v => ({
			Id: v.otherRetirementIncomeID ? v.otherRetirementIncomeID.toString() : 0,
			IncomeSourceTypeId: v.incomeSourceTypeId || 0,
			MonthlyIncome: v.monthlyIncome || 0,
		}))	;
	}else {
		return [{ Id: '', IncomeSourceTypeId: 0 }];
	}
};

export const parseGoalTypeToEnum = (goalType: number): GoalTypeEnum => {
	if(goalType === 1) {
		return GoalTypeEnum.Unknown;
	} else if(goalType === 2) {
		return GoalTypeEnum.Retirement;
	} else if(goalType === 3) {
		return GoalTypeEnum.GeneralSavings;
	} else {
		return GoalTypeEnum.NoGoal;
	}
};